import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { faqs } from "../data/landing";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="navy" cta="Yes, I Want the Complete Collection" data-id="element-108" data-mp="1cf03nb26x4mz">
      <SectionHeading eyebrow="Frequently asked questions" title="Your Questions, Answered" data-id="element-109" data-mp="1ccneacu3rrzw" />

      <div className="mx-auto mt-10 max-w-3xl divide-y divide-line border-y border-line" data-id="element-110" data-mp="29zw76swfo3bx">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-111" data-mp="2027zz3hn53cv" data-mpi={i}>
              <h3 data-id="element-112" data-mp="1v4zp7nyto1ln">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:text-gold" data-id="element-113" data-mp="1v5hjwg5u67rg">
                  <span className="text-base font-bold text-cream sm:text-lg" data-id="element-114" data-mp="1klnhe1ud82ie">{f.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-115" data-mp="1pm1rrqjfvojl" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-116" data-mp="11wz4o361d3hp">
                {isOpen && <motion.div id={`faq-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-117" data-mp="16np9nfajv4bv">
                    <p className="pb-5 text-base leading-relaxed text-muted" data-id="element-118" data-mp="mzyj6hefu4ro">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}